"use client";

import { useRouter } from "next/navigation";
import { useState } from "react";

import { LoyaltyRegisterForm } from "@saas/account/feature/loyalty/loyalty-register-form";
import { LoyaltyAccountRegisteredModal } from "@saas/account/ui/loyalty/loyalty-account-registered-modal/loyalty-account-registered-modal";
import { useLoyaltyBrandContext } from "@saas/loyalty/feature/@context/loyalty-brand/loyalty-brand.context";
import { createLoyaltyUrl } from "@saas/loyalty/utils/create-loyalty-url/create-loyalty-url";

export const RegisterClientPage = () => {
  const { brandSlug, brandName } = useLoyaltyBrandContext();

  const router = useRouter();

  const [isRegistered, setIsRegistered] = useState(false);

  const handleRegistered = () => {
    setIsRegistered(true);
  };

  const handleRedirect = () => {
    router.push(createLoyaltyUrl({ brandSlug }));
  };

  return (
    <>
      <LoyaltyRegisterForm onSuccess={handleRegistered} />

      <LoyaltyAccountRegisteredModal
        open={isRegistered}
        brandName={brandName}
        onRedirect={handleRedirect}
      />
    </>
  );
};
